'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tracker = {}; /* global window */

var trackerCDN = '//sdk.pulse.schibsted.com/loader-modern.min.js';

var lazyLoad = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!window.pulse) {
                            _context.next = 2;
                            break;
                        }

                        return _context.abrupt('return', window.pulse);

                    case 2:
                        _context.next = 4;
                        return (0, _util.load)(trackerCDN);

                    case 4:
                        if (window.pulse) {
                            _context.next = 6;
                            break;
                        }

                        throw new Error('Stalled: failed to load Pulse SDK using CDN: ' + trackerCDN);

                    case 6:
                        return _context.abrupt('return', window.pulse);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function lazyLoad() {
        return _ref.apply(this, arguments);
    }

    return lazyLoad;
}();

var initializeWithCb = function initializeWithCb(trackerId, pulse) {
    return new _promise2.default(function (resolve, reject) {
        return pulse(trackerId, function (initializedTracker) {
            if (initializedTracker) {
                return resolve(initializedTracker);
            }
            return reject(new Error('Stalled: failed to initialize Pulse SDK using CDN: ' + trackerCDN));
        });
    });
};

var initializeWithPromise = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(trackerId, pulse) {
        var initializedTracker;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return pulse;

                    case 2:
                        initializedTracker = _context2.sent;

                        if (!initializedTracker) {
                            _context2.next = 5;
                            break;
                        }

                        return _context2.abrupt('return', initializedTracker);

                    case 5:
                        throw new Error('Stalled: failed to initialize Pulse SDK using CDN: ' + trackerCDN);

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    function initializeWithPromise(_x, _x2) {
        return _ref2.apply(this, arguments);
    }

    return initializeWithPromise;
}();

var initialize = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(providerId, trackerId, pulse) {
        var asyncPulse;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        asyncPulse = pulse('init', providerId, null, null, trackerId);

                        if (!(asyncPulse && asyncPulse.then)) {
                            _context3.next = 3;
                            break;
                        }

                        return _context3.abrupt('return', initializeWithPromise(trackerId, asyncPulse));

                    case 3:
                        return _context3.abrupt('return', initializeWithCb(trackerId, pulse));

                    case 4:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    function initialize(_x3, _x4, _x5) {
        return _ref3.apply(this, arguments);
    }

    return initialize;
}();

exports.default = function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            providerId = _ref5.providerId,
            _ref5$trackerId = _ref5.trackerId,
            trackerId = _ref5$trackerId === undefined ? 'web-sdk' : _ref5$trackerId;

        var loadedPulse, initializedTracker;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        if (!tracker[trackerId]) {
                            _context4.next = 2;
                            break;
                        }

                        return _context4.abrupt('return', tracker[trackerId]);

                    case 2:
                        if (providerId) {
                            _context4.next = 4;
                            break;
                        }

                        throw new Error('providerId must be specified');

                    case 4:
                        _context4.next = 6;
                        return lazyLoad();

                    case 6:
                        loadedPulse = _context4.sent;
                        _context4.next = 9;
                        return initialize(providerId, trackerId, loadedPulse);

                    case 9:
                        initializedTracker = _context4.sent;

                        tracker[trackerId] = initializedTracker;

                        return _context4.abrupt('return', initializedTracker);

                    case 12:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function () {
        return _ref4.apply(this, arguments);
    };
}();
//# sourceMappingURL=pulse.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/trackers/pulse/loaders/pulse.js
 ** module id = 103
 ** module chunks = 0
 **/